import type { IconData } from '@stacksjs/iconify-core'

export const door: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M36.378 3.503c2.203.219 3.842 1.85 4.05 4.055C40.707 10.499 41 15.593 41 24s-.293 13.5-.572 16.442c-.208 2.205-1.847 3.836-4.05 4.055C33.856 44.748 29.864 45 24 45s-9.856-.252-12.378-.503c-2.203-.219-3.842-1.85-4.05-4.055C7.293 37.501 7 32.407 7 24s.293-13.5.572-16.442c.208-2.205 1.847-3.836 4.05-4.055C14.144 3.252 18.136 3 24 3s9.856.252 12.378.503M34 24h-4\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default door
